export default {
  Finance: () => import('./finance/index.vue'), // 财务统计
  Order: () => import('./order/index.vue'), // 订单统计
  Drug: () => import('./drug/index.vue'), // 药品统计
};
